import { render, staticRenderFns } from "./ver_responder_proyecto.vue?vue&type=template&id=2c4c65fb"
import script from "./ver_responder_proyecto.vue?vue&type=script&lang=js"
export * from "./ver_responder_proyecto.vue?vue&type=script&lang=js"
import style0 from "./ver_responder_proyecto.vue?vue&type=style&index=0&id=2c4c65fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports